var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cell-num" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { "padding-right": "50px" }, attrs: { span: 18 } },
            [
              _c("h4", { staticClass: "title" }, [_vm._v("访问排行榜")]),
              _c("ve-histogram", {
                ref: "chart",
                attrs: {
                  height: "400px",
                  "legend-visible": false,
                  data: _vm.data,
                  colors: ["#3aa1ff"],
                },
              }),
            ],
            1
          ),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("h4", { staticClass: "title" }, [_vm._v("访问排行榜")]),
            _c(
              "ul",
              { staticClass: "list" },
              _vm._l(_vm.rankList, function (item, index) {
                return _c("li", { key: index }, [
                  _c("span", { class: index < 3 ? "active" : null }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _c("span", [_vm._v(_vm._s(item.total))]),
                ])
              }),
              0
            ),
          ]),
        ],
        1
      ),
      _c("el-row"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }